<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>
      <v-card class="mx-auto" width="100%" max-width="500" outlined>
        <v-card-title>{{ $t('auth.thanks') }}</v-card-title>
        <v-card-text>
          <p>
            {{ $t('auth.verify') }} <b>{{ user.email }}</b>.
          </p>
          <v-btn
            depressed
            rounded
            right
            color="primary"
            href="/logout">
            {{ $t('auth.labels.logOut') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    user () {
      return this.$route.params.user
    }
  }
}
</script>
